import { isValidClientId } from './clientIdStorage';

import type { Configuration, SilentRequest } from '@azure/msal-browser';
import { env } from '@fjuel/configs/env';

export { clearStoredClientId, getStoredClientId, isValidClientId, storeClientId } from './clientIdStorage';

export const getMsalClientId = (clientId: string | null): string =>
  clientId && isValidClientId(clientId) ? clientId : env.VITE_MSAL_CLIENT_ID;

export const getRedirectUri = (): string => new URL('/redirect.html', window.location.origin).href;

export const createMsalConfig = (clientId: string | null): Configuration => {
  return {
    cache: {
      cacheLocation: 'localStorage',
    },
    auth: {
      clientId: getMsalClientId(clientId),
      redirectUri: getRedirectUri(),
      authority: env.VITE_MSAL_AUTHORITY,
      knownAuthorities: [env.VITE_MSAL_KNOWN_AUTH],
    },
  };
};

export const loginRequest: {
  scopes: SilentRequest['scopes'];
} = {
  scopes: [env.VITE_MSAL_SCOPE],
};
